/* Application: Example function
========================================================================== */

template.example = () => {
	// Example function
};
